import React, { useRef, useState } from "react";

import { DropDown, FocusedItem, SelectContainer } from "./styles";

import SelectOption from "../../../components/SelectOption";

const toMoneyFormat = (value) => {
  return Number(value / 100).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
};

function Teste2(props) {
  // const tryAgain = props.location.state.count;
  // console.log("[tryAgain]", tryAgain);

  // const backPage = () => {
  //   props.history.push("/teste", {count: tryAgain + 1} );
  // }

  // const queryString = window.location.search;
  // console.log("[queryString]", queryString);
  // const decodedQueryString = decodeURIComponent(queryString);
  // console.log("[decodedQueryString]", decodedQueryString);
  const searchParams = new URLSearchParams(window.location.search);
  console.log("[searchParams]", searchParams);
  console.log("[type]", typeof searchParams);

  const param1 = searchParams.get("payment");
  const param2 = searchParams.get("checkout_web");

  const paymentValue = JSON.parse(param1);
  const checkoutValue = JSON.parse(param2);
  console.log("[checkoutValue]", checkoutValue);

  return (
    // <div>
    //   <button type="button" onClick={backPage} style={{ height: '65px' }}>
    //     Voltar para a pagina
    //   </button>
    // </div>
    <div>
      <div style={{ margin: "25px" }}>
        <span>Dados de payment ------------------------</span>
        {Object.keys(paymentValue).map((item, i) => (
          <div key={i}>
            <span>{item}:</span>
            <span>{paymentValue[item]}</span>
          </div>
        ))}
      </div>

      <div style={{ margin: "25px" }}>
        <span>Dados do checkout ------------------------</span>
        {Object.keys(checkoutValue).map((item, i) => (
          <div key={i}>
            <span>{item}:</span>
            <span>
              {checkoutValue[item].constructor === Object
                ? JSON.stringify(checkoutValue[item])
                : checkoutValue[item]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Teste2;
